import './App.css';
import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { Login } from './actions/actions.js'
import { cookies_string } from './config.js'
import { validToken } from './services/request.service.js'
import { useEffect } from 'react';

import MenuBar from './screens/Header.js';
import PageNotFound from './screens/PageNotFound.js'
import LoginPage from './screens/LoginPage.js'

//admin pages
import AdminHomePage from './screens/admin/Home.js';
import AdminMenu from './screens/admin/components/Menu.js';
import AdminMissionsPage from './screens/admin/Missions.js';
import AdminMissionsDetailsPage from './screens/admin/MissionsDetails.js';
import AdminResultsPage from './screens/admin/Results.js';
import AdminResultsDetailsPage from './screens/admin/ResultsDetails.js';
import AdminResultsSchoolDetailsPage from './screens/admin/ResultsSchoolDetails.js';
import AdminUsersPage from './screens/admin/Users.js';
import AdminFaqPage from './screens/admin/Faq.js';
import AdminSchoolPage from './screens/admin/School.js';
import AdminRegistrationsPage from './screens/admin/Registrations.js';
import AdminResultsStudentMissionsPage from './screens/admin/ResultsStudentMissions.js';
import AdminResultsStudentReportPage from './screens/admin/ResultsStudentReport.js';
import AdminQuestionnairesPage from './screens/admin/Questionnaires.js';
import AdminQuestionnaireDetailPage from './screens/admin/QuestionnaireDetail.js';
import AdminQuestionnaireResultPage from './screens/admin/QuestionnaireResult.js';
import AdminResultsSchoolStatisticPage from './screens/admin/ResultsSchoolStatistic.js';
import AdminResultsStudentQuestionnairePage from './screens/admin/ResultsStudentQuestionnaire.js';
import AdminResultsAllStatisticPage from './screens/admin/ResultsAllStatistic.js';

//teacher pages
import TeacherHomePage from './screens/teacher/Home.js';
import TeacherMenu from './screens/teacher/components/Menu.js';
import TeacherResultsPage from './screens/teacher/Results.js';
import TeacherResultDetailsPage from './screens/teacher/ResultDetails.js';
import TeacherResultsStudentMissionPage from './screens/teacher/ResultsStudentMission.js';
import TeacherResultsStudentReportPage from './screens/teacher/ResultsStudentReport.js';
import TeacherSchoolDetailsPage from './screens/teacher/SchoolDetails.js';
import TeacherManageStudentsPage from './screens/teacher/ManageStudents.js';
import TeacherManageMissionsPage from './screens/teacher/ManageMissions.js';
import TeacherResultStatisticPage from './screens/teacher/ResultStatistic.js';

//student pages
import StudentHomePage from './screens/student/Home.js';
import StudentMissionsPage from './screens/student/Missions.js';
import StudentMissionsDetailsPage from './screens/student/MissionsDetails.js';
import StudentMenu from './screens/student/components/Menu.js';
import StudentRecordsPage from './screens/student/Records.js';
import StudentResultsStudentReportPage from './screens/student/ResultsStudentReport.js';
import StudentResultsStudentMissionsPage from './screens/student/ResultsStudentMissions.js';

//primary admin pages
import PrimaryAdminRegistrationsPage from './screens/primary_admin/Registrations.js';
import PrimaryAdminMissionsPage from './screens/primary_admin/Missions.js';
import PrimaryAdminMissionsDetailsPage from './screens/primary_admin/MissionsDetails.js';
import PrimaryAdminUsersPage from './screens/primary_admin/Users.js';
import PrimaryAdminSchoolPage from './screens/primary_admin/School.js';
import PrimaryAdminQuestionnairesPage from './screens/primary_admin/Questionnaires.js';
import PrimaryAdminQuestionnaireDetailPage from './screens/primary_admin/QuestionnaireDetail.js';
import PrimaryAdminQuestionnaireResultPage from './screens/primary_admin/QuestionnaireResult.js';
import PrimaryAdminResultsPage from './screens/primary_admin/Results.js';
import PrimaryAdminResultsDetailsPage from './screens/primary_admin/ResultsDetails.js';
import PrimaryAdminResultsSchoolDetailsPage from './screens/primary_admin/ResultsSchoolDetails.js';
import PrimaryAdminResultsSchoolStatisticPage from './screens/primary_admin/ResultsSchoolStatistic.js';
import PrimaryAdminResultsAllStatisticPage from './screens/primary_admin/ResultsAllStatistic.js';
import PrimaryAdminResultsStudentMissionsPage from './screens/primary_admin/ResultsStudentMissions.js';
import PrimaryAdminResultsStudentReportPage from './screens/primary_admin/ResultsStudentReport.js';
import PrimaryAdminResultsStudentQuestionnairePage from './screens/primary_admin/ResultsStudentQuestionnaire.js';

//primary student pages
import PrimaryStudentHomePage from './screens/primary_student/Home.js';
import PrimaryStudentMissionsPage from './screens/primary_student/Missions.js';
import PrimaryStudentMissionsDetailsPage from './screens/primary_student/MissionsDetails.js';
import PrimaryStudentMenu from './screens/primary_student/components/Menu.js';
import PrimaryStudentRecordsPage from './screens/primary_student/Records.js';
import PrimaryStudentResultsStudentReportPage from './screens/primary_student/ResultsStudentReport.js';
import PrimaryStudentResultsStudentMissionsPage from './screens/primary_student/ResultsStudentMissions.js';

//primary teacher pages
import PrimaryTeacherHomePage from './screens/primary_teacher/Home.js';
import PrimaryTeacherMenu from './screens/primary_teacher/components/Menu.js';
import PrimaryTeacherResultsPage from './screens/primary_teacher/Results.js';
import PrimaryTeacherResultDetailsPage from './screens/primary_teacher/ResultDetails.js';
import PrimaryTeacherResultsStudentMissionPage from './screens/primary_teacher/ResultsStudentMission.js';
import PrimaryTeacherResultsStudentReportPage from './screens/primary_teacher/ResultsStudentReport.js';
import PrimaryTeacherSchoolDetailsPage from './screens/primary_teacher/SchoolDetails.js';
import PrimaryTeacherManageStudentsPage from './screens/primary_teacher/ManageStudents.js';
import PrimaryTeacherManageMissionsPage from './screens/primary_teacher/ManageMissions.js';
import PrimaryTeacherResultStatisticPage from './screens/primary_teacher/ResultStatistic.js';

function App(props) {
  const [cookies, setCookie, removeCookie] = useCookies([`${cookies_string}_cred`, `${cookies_string}_token`]);
  useEffect(() => {
    async function check_token() {
      let login_cred = cookies[`${cookies_string}_cred`];
      let token = cookies[`${cookies_string}_token`];
      if (token && login_cred) {
        let res = await validToken(token)
        if (res?.errno === 0 && login_cred.username && login_cred.usertype) {
          props.dispatch(Login(true, token, login_cred.usertype, login_cred.username))
        }
      } else {
        try {
          removeCookie(`${cookies_string}_token`, '/')
        } catch (e) {
          console.log('cookie err:', e)
        }
      }
    }
    check_token()
  }, [])

  if (!props.token.isLogin)
    return (
      <LoginPage />
    );

  if (props.token.usertype === 'admin')
    return (
      <div className="root" style={{}}>
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <AdminMenu />
          <Routes>
            <Route path="/" element={<AdminHomePage />} />
            <Route path="/home" element={<AdminHomePage />} />
            <Route path="/missions" element={<AdminMissionsPage />} />
            <Route path="/missions/:id" element={<AdminMissionsDetailsPage />} />
            <Route path="/results" element={<AdminResultsPage />} />
            <Route path="/results/:id" element={<AdminResultsDetailsPage />} />
            <Route path="/results/:id/:schoolId" element={<AdminResultsSchoolDetailsPage />} />
            <Route path="/results/statistic/all/:id" element={<AdminResultsAllStatisticPage />} />
            <Route path="/results/statistic/:id/:schoolId" element={<AdminResultsSchoolStatisticPage />} />
            <Route path='/studentmissions/:id' element={<AdminResultsStudentMissionsPage />} />
            <Route path='/studentreports/:id' element={<AdminResultsStudentReportPage />} />
            <Route path='/studentquestionnaire/:id' element={<AdminResultsStudentQuestionnairePage />} />
            <Route path="/users" element={<AdminUsersPage />} />
            <Route path="/users/school/:id" element={<AdminSchoolPage />} />
            <Route path="/faq" element={<AdminFaqPage />} />
            <Route path="/registrations" element={<AdminRegistrationsPage />} />
            <Route path="/questionnaires" element={<AdminQuestionnairesPage />} />
            <Route path="/questionnaires/:id" element={<AdminQuestionnaireDetailPage />} />
            <Route path="/questionnaires/result/:id" element={<AdminQuestionnaireResultPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'teacher')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <TeacherMenu />
          <Routes>
            <Route path="/" element={<TeacherHomePage />} />
            <Route path="/results" element={<TeacherResultsPage />} />
            <Route path="/results/:id" element={<TeacherResultDetailsPage />} />
            <Route path="/results/statistic/:id" element={<TeacherResultStatisticPage />} />
            <Route path="/studentmissions/:id" element={<TeacherResultsStudentMissionPage />} />
            <Route path="/studentreports/:id" element={<TeacherResultsStudentReportPage />} />
            <Route path="/users" element={<TeacherSchoolDetailsPage />} />
            <Route path="/students" element={<TeacherManageStudentsPage />} />
            <Route path="/missions" element={<TeacherManageMissionsPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'student')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <StudentMenu />
          <Routes>
            <Route path="/" element={<StudentHomePage />} />
            <Route path="/missions" element={<StudentMissionsPage />} />
            <Route path="/missions/:id" element={<StudentMissionsDetailsPage />} />
            <Route path="/records" element={<StudentRecordsPage />} />
            <Route path="/studentmissions/:id" element={<StudentResultsStudentMissionsPage />} />
            <Route path="/studentreports/:id" element={<StudentResultsStudentReportPage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'p-admin') {
    return (
      <div className="root" style={{}}>
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <AdminMenu />
          <Routes>
            <Route path="/" element={<AdminHomePage />} />
            <Route path="/home" element={<AdminHomePage />} />
            <Route path="/registrations" element={<PrimaryAdminRegistrationsPage />} />
            <Route path="/missions" element={<PrimaryAdminMissionsPage />} />
            <Route path="/missions/:id" element={<PrimaryAdminMissionsDetailsPage />} />
            <Route path="/faq" element={<AdminFaqPage />} />
            <Route path="/users" element={<PrimaryAdminUsersPage />} />
            <Route path="/users/school/:id" element={<PrimaryAdminSchoolPage />} />
            <Route path="/questionnaires" element={<PrimaryAdminQuestionnairesPage />} />
            <Route path="/questionnaires/:id" element={<PrimaryAdminQuestionnaireDetailPage />} />
            <Route path="/questionnaires/result/:id" element={<PrimaryAdminQuestionnaireResultPage />} />
            <Route path="/results" element={<PrimaryAdminResultsPage />} />
            <Route path="/results/:id" element={<PrimaryAdminResultsDetailsPage />} />
            <Route path="/results/:id/:schoolId" element={<PrimaryAdminResultsSchoolDetailsPage />} />
            <Route path="/results/statistic/all/:id" element={<PrimaryAdminResultsAllStatisticPage />} />
            <Route path="/results/statistic/:id/:schoolId" element={<PrimaryAdminResultsSchoolStatisticPage />} />
            <Route path='/studentmissions/:id' element={<PrimaryAdminResultsStudentMissionsPage />} />
            <Route path='/studentreports/:id' element={<PrimaryAdminResultsStudentReportPage />} />
            <Route path='/studentquestionnaire/:id' element={<PrimaryAdminResultsStudentQuestionnairePage />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );
  }


  if (props.token.usertype === 'p-teacher')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <PrimaryTeacherMenu />
          <Routes>
            <Route path="/" element={<PrimaryTeacherHomePage />} />
            <Route path="/users" element={<PrimaryTeacherSchoolDetailsPage />} />
            <Route path="/students" element={<PrimaryTeacherManageStudentsPage />} />
            <Route path="/results" element={<PrimaryTeacherResultsPage />} />
            <Route path="/results/:id" element={<PrimaryTeacherResultDetailsPage />} />
            <Route path="/studentmissions/:id" element={<PrimaryTeacherResultsStudentMissionPage />} />
            <Route path="/missions" element={<PrimaryTeacherManageMissionsPage />} />
            <Route path="/results/statistic/:id" element={<PrimaryTeacherResultStatisticPage />}/>
            <Route path="/studentreports/:id" element={<PrimaryTeacherResultsStudentReportPage />}/>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );

  if (props.token.usertype === 'p-student')
    return (
      <div className="root">
        <MenuBar />
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <PrimaryStudentMenu />
          <Routes>
            <Route path="/" element={<PrimaryStudentHomePage />} />
            <Route path="/missions" element={<PrimaryStudentMissionsPage />} />
            <Route path="/missions/:id" element={<PrimaryStudentMissionsDetailsPage />} />
            <Route path="/studentmissions/:id" element={<PrimaryStudentResultsStudentMissionsPage />}/>
            <Route path="/records" element={<PrimaryStudentRecordsPage />}/>
            <Route path="/studentreports/:id" element={<PrimaryStudentResultsStudentReportPage />}/>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );


  return (<PageNotFound />)
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)